import { native } from '@forest/native-services'
import { EnterCodeSheet } from './enter-code-sheet'
import { ArrowLeft } from './icons'
import { ProgressiveBlur } from './progressive-blur'

export function TopNav() {
  return (
    <div class="fixed inset-x-0 top-0 z-20 min-w-[320px] px-[10px] pb-3 pt-[calc(var(--safe-area-top)+12px)]">
      <ProgressiveBlur strong="top" maxBlur={10} />

      <div class="relative z-10 flex items-end justify-between">
        <button
          type="button"
          aria-label="Back"
          onClick={() => {
            // Claims on this page credit coins/gems server-side only — sync
            // before closing so the app's local balance reflects them.
            void native.data.fullSync()
            void native.general.close()
          }}
          style={{ '--ow': '1.75px' }}
          class="gradient-outline flex size-[42px] items-center justify-center rounded-full bg-white/[0.56] text-ink backdrop-blur-xl"
        >
          <ArrowLeft class="size-5 text-[#666]" />
        </button>

        <EnterCodeSheet />
      </div>
    </div>
  )
}
